import classNames from 'classnames';
import style from './style.module.scss';
import {IProductShort} from 'modules/products/types';
import React, {MouseEventHandler, useState} from 'react';

export interface IProps {
    article: IProductShort['id'];
}

export const ProductArticle = ({article}: IProps) => {
    const [isShownCopied, setIsShownCopied] = useState(false);
    const [isFade, setIsFade] = useState(false);

    const handleArticleClick: MouseEventHandler<HTMLButtonElement> = (e) => {
        e.preventDefault();
        navigator.clipboard.writeText((e.target as HTMLElement).innerText);
        setIsShownCopied(true);
        setIsFade(true);
        setTimeout(() => {
            setIsFade(false);
        }, 1500);
        setTimeout(() => {
            setIsShownCopied(false);
        }, 2000);
    };

    return (
        <>
            <button className={style.visualProductCardArticle} onClick={handleArticleClick}>
                {article}
            </button>
            {isShownCopied && (
                <div className={classNames(style.copied, {[style.copiedShown]: isFade})}>Скопировано</div>
            )}
        </>
    );
};
